/** @typedef {'X' | 'O' | null} Cell */
/** @typedef {Cell[]} Board */

export const WIN_LINES = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];

export function emptyBoard() {
  return /** @type {Board} */ (Array(9).fill(null));
}

/**
 * @param {Board} board
 * @returns {{ winner: 'X' | 'O', line: number[] } | null}
 */
export function checkWinner(board) {
  for (const [a, b, c] of WIN_LINES) {
    const v = board[a];
    if (v && v === board[b] && v === board[c]) {
      return { winner: v, line: [a, b, c] };
    }
  }
  return null;
}

/**
 * @param {Board} board
 */
export function isBoardFull(board) {
  return board.every((c) => c !== null);
}

/**
 * @param {Board} board
 * @returns {number[]}
 */
export function getAvailableMoves(board) {
  const out = [];
  for (let i = 0; i < 9; i += 1) {
    if (board[i] === null) out.push(i);
  }
  return out;
}

/**
 * @param {Board} board
 * @param {number} index
 * @param {'X' | 'O'} player
 * @returns {Board}
 */
export function applyMove(board, index, player) {
  const next = [...board];
  next[index] = player;
  return next;
}

/**
 * @param {Board} board
 * @returns {'X' | 'O' | 'draw' | null}
 */
export function gameOutcome(board) {
  const w = checkWinner(board);
  if (w) return w.winner;
  if (isBoardFull(board)) return 'draw';
  return null;
}
